import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/styles';
import Link from '@material-ui/core/Link';
import { removeCookie } from 'src/utils';
import { gapiChecking } from 'src/services/gapi/actions';
import { service as sessionService } from 'src/services/session';
import ErrorBoundary from 'src/containers/error-boundary';
import Init, { AUTH_HEADER } from './init';
import Background from './components/background';
import Bottom from './components/bottom';
import Panel from './components/panel';
import styles from './styles';

class Login extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (this.props.sessionRequest.fetching && !nextProps.sessionRequest.fetching) {
      this.afterCheckSession(nextProps.sessionRequest);
    }
  }

  afterCheckSession = ({ formattedError }) => {
    if (formattedError) {
      removeCookie(AUTH_HEADER);

      if (formattedError === 401) {
        return;
      }

      const error = !isNaN(formattedError) && formattedError >= 400 && formattedError < 500
        ? (
          <>
            Error. You do not have access to the requested resource.
            <br/>
            Please contact <Link href="mailto:dfadmin-core-team@google.com">
              dfadmin-core-team@google.com
            </Link> to request access
          </>
        ) : formattedError;

      this.setState({ error })
    } else {
      this.setState({ error: null });
      window.location.reload();
    }

    this.props.actions.gapiChecking(false);
  };

  onLoad = () => {
    this.userHandler();
  };

  userHandler = () => {
//    if (auth2.isSignedIn.get()) {
//      this.props.actions.checkSession();
//    } else {
//      removeCookie(AUTH_HEADER);
//    }
  };

  render() {
    const { classes } = this.props;

    return (
      <ErrorBoundary>
        <div className={classes.login}>
          <Init onLoad={this.onLoad} />
          <Background />
          <Panel error={this.state.error} />
          <Bottom />
        </div>
      </ErrorBoundary>
    );
  }
}

Login.propTypes = {
  sessionRequest: PropTypes.shape({
    data: PropTypes.shape({
      success: PropTypes.bool,
    }).isRequired,
    fetching: PropTypes.bool.isRequired,
    error: PropTypes.string,
  }).isRequired,
  actions: PropTypes.shape({
    checkSession: PropTypes.func.isRequired,
    gapiChecking: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    login: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  sessionRequest: state.session.get,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    checkSession: sessionService.getFlow('get').request,
    gapiChecking,
  }, dispatch),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
)(Login);
